var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5306 12.4693C10.6715 12.6102 10.7507 12.8013 10.7507 13.0006C10.7507 13.1998 10.6715 13.3909 10.5306 13.5318C10.3897 13.6727 10.1986 13.7519 9.99938 13.7519C9.80012 13.7519 9.60902 13.6727 9.46813 13.5318L4.46813 8.53182C4.39821 8.46214 4.34273 8.37935 4.30488 8.28818C4.26702 8.19702 4.24754 8.09928 4.24754 8.00057C4.24754 7.90186 4.26702 7.80412 4.30488 7.71295C4.34273 7.62179 4.39821 7.539 4.46813 7.46932L9.46813 2.46932C9.60902 2.32842 9.80012 2.24927 9.99938 2.24927C10.1986 2.24927 10.3897 2.32842 10.5306 2.46932C10.6715 2.61021 10.7507 2.80131 10.7507 3.00057C10.7507 3.19983 10.6715 3.39092 10.5306 3.53182L6.0625 7.99994L10.5306 12.4693Z",
    fill: "#0B1A29"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.7dfd15ee391a8425ca87c0f532637168.svg";
export { ForwardRef as ReactComponent };